export const SHARED_BROWSER = 'shared-browser';
export const BROWSER_PLAYER_PARTICIPANT_NAME = 'Shared Browser';
export const ALLOWED_PROTOCOLS = ['http:', 'https:'];
export const BROWSER_EVENTS = {
    OPEN: 'BROWSER_OPEN',
    CLOSE: 'BROWSER_CLOSE',
    NAVIGATE: 'BROWSER_NAVIGATE',
    BACK: 'BROWSER_BACK',
    FORWARD: 'BROWSER_FORWARD',
    RELOAD: 'BROWSER_RELOAD',
    SYNC_STATE: 'BROWSER_SYNC_STATE',
    SYNC_SCROLL: 'BROWSER_SYNC_SCROLL'
};
